import { memo } from 'react';

import { Box, ButtonBase, Stack, Typography } from '@mui/material';

type VersionThumbProps = {
  active: boolean;
  disabled?: boolean;
  onClick?: () => void;
  label: string;
  children: React.ReactNode;
};

export const VersionThumb = memo(
  ({ active, disabled, onClick, label, children }: VersionThumbProps) => (
    <ButtonBase
      aria-pressed={active}
      disabled={disabled}
      onClick={event => {
        event.stopPropagation();
        onClick?.();
      }}
      sx={{
        display: 'block',
        width: '100%',
        flexShrink: 0,
        textAlign: 'left',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          aspectRatio: '4 / 3',
          borderRadius: 2,
          overflow: 'hidden',
          border: 2,
          borderColor: active ? 'primary.main' : 'transparent',
          outline: active ? 'none' : '1px solid',
          outlineColor: active ? 'transparent' : 'divider',
          outlineOffset: -2,
          ...(!disabled && { '&:hover': { borderColor: 'primary.light' } }),
        }}
      >
        {children}
      </Box>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          mt: 0.75,
          px: 0.5,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontWeight: active ? 700 : 500,
            color: active ? 'primary.main' : 'text.secondary',
          }}
        >
          {label}
        </Typography>
      </Stack>
    </ButtonBase>
  ),
);
